import React from "react";
import { Card } from "react-bootstrap";
import Chart from "react-apexcharts";
import { GraphCardsHeader } from "@ui";

function HeatMapsChart({ title, height = 300, series }) {
  const chartOptions = {
    series: series || [],
    options: {
      chart: {
        height: 350,
        type: "heatmap",
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#0f2d70"],
      yaxis: {
        labels: {
          formatter: function (value) {
            return value ? value + " ( % ) " : "";
          },
        },
      },
    },
  };

  function exportCSV() {
    if (!series || !series.length) return;
    let csvContent = "Date,Time Slot,Value\n";
    series.forEach((item) => {
      const date = item.name;
      item.data.forEach((point) => {
        csvContent += `${date},${point.x},${point.y}\n`;
      });
    });
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "chart_data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  return (
    <Card className="h-100 m-0">
      <GraphCardsHeader
        title={title}
        titleCenter={false}
        showDownloadButtons={true}
        needCSVDownload={true}
        downloadCSV={exportCSV}
      />
      <Card.Body className="p-2">
        <div id="chart">
          <Chart
            options={chartOptions.options}
            series={chartOptions.series}
            type="heatmap"
            height={height}
          />
        </div>
      </Card.Body>
    </Card>
  );
}

export default HeatMapsChart;
